(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  ns.LegendView = Backbone.View.extend({
		el: ".legend-container",
    name: "Map Legend",
    templateSelector: "#map-legend-template",

    initialize: function() {
      this.initialRenderPromise = $.Deferred();

      var self = this;
      _.bindAll(this, "render");

      this.model.on("change", this.render);

      // Hide the legend text when a data update begins
      this.model.on("busy", function() {
        self.$el.hide();
      });

      // Show/hide the legend when the "+/-" button is clicked
      this.$el.on("click", ".icon-map-overlay-control", function(e) {
        e.preventDefault();

				var $content = $(".map-overlay-content", $(e.target).parents('.map-overlay-block'));
        if (self.isClosed) {
          // Show it
					$content.parent().removeClass("closed");
          $content.slideDown();
          self.isClosed = false;
        }
        else {
          // Hide it
          $content.slideUp(400, function() {
						$content.parent().addClass("closed");
          });
          self.isClosed = true;
        }
			});

			// Boundary overlay radios
			$('.boundary-radio-hidden, .boundary-radio-hidden::before, .boundary-overlay-list label').click(function (e) {
				$('.boundary-radio-hidden').each(function (_index, radio) {
					$(radio).prop('checked', null);
				});

				var $hiddenRadio = $('.boundary-radio-hidden', $(e.target).parents('li'));
				$hiddenRadio.prop('checked', true);
				var radioVal = $hiddenRadio.val();
				var overlayVals = radioVal
					? [radioVal]
					: null;
				self.model.selectorsModel.set('overlays', overlayVals);
			
				e.preventDefault();
				e.stopPropagation();
      });
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    render: function() {
      var self = this;

      // Verify this selector's container is present
      if (this.$el.length === 0) {
        throw "Could not find the " + this.name + " container: " + this.el;
      }

      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
			
			var overlay = self.model.selectorsModel.get('overlays');
			if (overlay) {
				// Update boundary overlay legend so it reflects the model
				var overlayId = Array.isArray(overlay)
					? overlay[0]
					: overlay.toString().split(',')[0]; 
				$('.boundary-radio-hidden[value="' + overlayId + '"]')
					.prop('checked', true);
			}
      // Pull the data summary from the global selector instance.
      var summary = ccc.viz.map.views.instances.SelectorsView.getDataSummaryByPropertyNames(
        ["indicatorId"]
      );
      var response = this.model.get("response");
      if (_.str.isBlank(summary)) {
        summary = response.indicatorGroupName;
      }

      var largerValuesAre = response.largerValuesAre;

      var themeColors = ccc.viz.map.config.MapConfig.themeColors.slice();

      if (largerValuesAre == "worse" || largerValuesAre == "neutral") {
        themeColors = themeColors.reverse();
      }

      // Re-render the control
      var legendInfo = _.extend(
        {
          title: summary,
          themeColors: themeColors,
          largerValuesAre: largerValuesAre
        },
        response
      );

      // Allow the container to resize to fit content once again
      this.$el.css("height", "auto");
      this.$el.css("width", "auto");

      // Insert the new HTML
			$('.map-legend-container').remove();
			this.$el.prepend(this.template(legendInfo));

      // Show it
      if (this.isClosed) {
        $(".map-overlay-content", self.el).hide();
      }
      this.$el.fadeIn(600, function() {
        self.initialRenderPromise.resolve();
      });
    }
  });
})(jQuery, _);
